import React from 'react';
import { Swiper } from 'swiper/js/swiper.esm';
import ReactSwiper from 'react-id-swiper/lib/ReactIdSwiper.custom';

function CustomSwiper({ params, children }) {
  const opts = {
    Swiper,
    ...params,
  };

  return <ReactSwiper {...opts}>{children}</ReactSwiper>;
}

export default CustomSwiper;
